import { API_URL } from 'common/services/apiClient';
import { apiFetch } from 'common/services/apiFetch';
import { VersionData } from '../types/types';

export async function fetchBackendVersion(): Promise<VersionData> {
	const res = await apiFetch(`${API_URL}/version`);
	return res.json() as Promise<VersionData>;
}
